/* Listen to native variant changes; the guide never changes commerce state. */
(() => {
  class SoBeMiamiMousseGuide extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const prefix = `product-form-main-${this.dataset.productId}-`;
      document.addEventListener('variant:change', (event) => {
        if (!event.target.getAttribute?.('id')?.startsWith(prefix)) return;
        this.showVariant(event.detail?.variant?.id);
      }, { signal: this.abortController.signal });
      const form = [...document.forms].find((item) => item.getAttribute('id')?.startsWith(prefix) && !item.getAttribute('id').endsWith('payment-installment'));
      this.showVariant(form?.elements.namedItem('id')?.value || this.dataset.variantId);
    }
    disconnectedCallback() { this.abortController?.abort(); }
    showVariant(id) {
      const selected = ['47804183478423', '47804183511191'].includes(String(id)) ? String(id) : 'unknown';
      this.querySelectorAll('[data-miami-guide]').forEach((panel) => {
        panel.hidden = panel.dataset.miamiGuide !== selected;
      });
    }
  }
  if (!customElements.get('sobe-miami-mousse-guide')) customElements.define('sobe-miami-mousse-guide', SoBeMiamiMousseGuide);
})();
